import { createStore, StoreOptions, Store, useStore as useVuexStore } from 'vuex';
import { RootState } from './types';
import { auth } from './auth/index';
import { general } from './general/index';
import { cart } from './cart/index';
import { checkout } from './checkout/index';
import { payment } from './payment/index';
import { content } from './content/index';
import { myBooking } from './myBooking/index';
import { myBookingSession } from './myBookingSession/index';
import { myBookingCredentials } from '@/store/myBookingCredentials';
import { myBookings } from './myBookings';
import { preCheckout } from './preCheckout/index';
import { metaFlight } from '@/store/metaFlight';

const initialState: any = {};
const store: StoreOptions<RootState> = {
    state: { version: '1.0.0', ...initialState },
    modules: {
        auth,
        general,
        cart,
        checkout,
        payment,
        content,
        myBooking,
        myBookingSession,
        myBookingCredentials,
        myBookings,
        preCheckout,
        metaFlight,
    },
};

export default createStore<RootState>(store);

export function useStore(): Store<RootState> {
    return useVuexStore();
}
